<pui-page-header [title]="'Podmioty uprawnione'">
  <pui-breadcrumbs>
    <a pui-breadcrumbs-item href="/">
      <pui-icon icon="home-line" />
    </a>
    <a pui-breadcrumbs-item href="/">Podmioty uprawnione</a>
  </pui-breadcrumbs>
  <button pui-button variant="primary" (click)="onAdd()">Dodaj podmiot <pui-icon icon="plus" left />
  </button>
</pui-page-header>


<div class="page-container">
  <pui-table2 [dataSource]="filteredAuthorizedEntity()" [trackBy]="trackBy" [sortBy]="sort().key"
    [sortDirection]="sort().direction" (sortChange)="onSortChange($event)">
    <ng-container header>
      <form class="d-flex align-items-center gap-16 justify-content-between w-100" [formGroup]="filtersForm">
        <pui-form-field>
          <pui-label>Wyszukaj</pui-label>
          <pui-icon icon="search-md" left />
          <input puiInput [placeholder]="'Wyszukaj'" formControlName="global" />
        </pui-form-field>
        <pui-divider orientation="vertical" />
        <pui-form-field>
          <pui-label>Typ</pui-label>
          <pui-select [multiple]="false" formControlName="groupValue">
            <pui-placeholder>Typ</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            @for(option of groupTypeOptions; track $index){
            <pui-option [value]="option">{{option}}</pui-option>
            }
          </pui-select>
        </pui-form-field>
      </form>
    </ng-container>
    <ng-template #header>
      <th>Nazwa</th>
      <th>Typ</th>
      <th pui-column-header key="reason">Osoby upoważnione</th>
      <th>Akcje</th>
    </ng-template>
    <ng-template #row let-row>
      <tr (click)="onShowDetails(row, $event)">
        <td>
          <button (click)="onToggleRow(row, $event)" pui-button variant="tertiary">
            <pui-icon [icon]="isExpanded(row) ? 'chevron-down' : 'chevron-right'"></pui-icon>
          </button>
          {{ row.name }}
        </td>
        <td><pui-badge [variant]="row.groupValue | groupColor">{{row.groupValue}}</pui-badge></td>
        <td>{{ row?.authorizedPeople?.length || 0 }}</td>
        <td>
          <button pui-button variant="tertiary" (click)="onAddUser(row, $event)"><pui-icon class="action-icon" left
              icon="user-plus-01" /></button>
          <button pui-button variant="tertiary" (click)="onEdit(row, $event)"><pui-icon class="action-icon" left
              icon="edit-03" /></button>
          <button pui-button variant="tertiary" (click)="onDelete(row, $event)"><pui-icon left icon="trash-03"
              class="remove-icon" /></button>
        </td>
      </tr>

      <tr *ngIf="isExpanded(row)" class="detail-row">
        <td colspan="6">
          <rqa-authorized-entity-users [entityUsers]="row?.authorizedPersons || []"
            [entityId]="row.uuid"></rqa-authorized-entity-users>
        </td>
      </tr>

    </ng-template>
    <pui-empty-state icon="file-x-02" title="Nie masz jeszcze żadnych podmiotów uprawnionych">
      <button pui-button variant="primary" (click)="onAdd()">Dodaj podmiot<pui-icon icon="plus" left /></button>
    </pui-empty-state>
  </pui-table2>
</div>
<rqa-authorized-entity-details></rqa-authorized-entity-details>